export type AppMode = 'emergency' | 'hospitality';

export const DEFAULT_APP_MODE: AppMode = 'emergency';
